import styled, { css } from "styled-components";

type Tone = "default" | "success" | "warning";

const getToneStyles = (tone: Tone) => {
    switch (tone) {
        case "success":
            return css`
                border-color: ${({ theme }) => theme.successTypographyColor};
                background: color-mix(
                    in srgb,
                    ${({ theme }) => theme.successTypographyColor} 10%,
                    ${({ theme }) => theme.secondaryBackgroundColor}
                );
            `;
        case "warning":
            return css`
                border-color: ${({ theme }) => theme.colors.warning};
                background: color-mix(
                    in srgb,
                    ${({ theme }) => theme.colors.warning} 12%,
                    ${({ theme }) => theme.secondaryBackgroundColor}
                );
            `;
        default:
            return css`
                border-color: ${({ theme }) => theme.secondaryBorderColor};
                background: ${({ theme }) => theme.secondaryBackgroundColor};
            `;
    }
};

export const StyledPreviewCard = styled.div<{ $tone: Tone }>`
    margin: 0 auto;
    position: relative;
    width: 220px;
    height: 220px;
    border-radius: 24px;
    overflow: hidden;
    border: 1px solid;
    cursor: pointer;
    transition:
        transform 0.2s ease,
        border-color 0.2s ease,
        box-shadow 0.2s ease;

    ${({ $tone }) => getToneStyles($tone)}

    &:active {
        transform: scale(0.985);
    }
`;

export const StyledPreviewImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
`;

export const StyledEmptyPreview = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
        180deg,
        ${({ theme }) => theme.secondaryBackgroundColor} 0%,
        color-mix(
                in srgb,
                ${({ theme }) => theme.colors.primary} 8%,
                ${({ theme }) => theme.secondaryBackgroundColor}
            )
            100%
    );

    .anticon {
        font-size: 72px;
        color: ${({ theme }) => theme.secondaryTypographyColor};
    }
`;

export const StyledPreviewBadge = styled.div`
    position: absolute;
    right: 12px;
    bottom: 12px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.16);

    .anticon {
        font-size: 18px;
    }
`;
